import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectSelectedTake3D,
  selectSelectedTakeActors,
} from "../../../app/slices/TrainingSlice";
import ActorAvatar from "../../../components/actors/ActorAvatar";
import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import PropIcon from "../../../icons/PropIcon";
import usePropHelper from "../../../hooks/PropHelper";
import { Prop } from "../../../models/Prop";

export default function NodeActorPropDropdown(props: {
  label: string;
  selectedObjectId: string;
  onClick: (objectId: string) => void;
  availableProps?: Prop[];
}) {
  const actors = useSelector(selectSelectedTakeActors);
  const take = useSelector(selectSelectedTake3D);
  const { getAllInvolvedProps } = usePropHelper();

  const propsInTake =
    props.availableProps ?? (take ? getAllInvolvedProps(take) : []);

  const selectedActor = actors.find((a) => a.id === props.selectedObjectId);
  const selectedProp = propsInTake.find((p) => p.id === props.selectedObjectId);

  const dropdownItems = [
    ...actors.map((a) => (
      <PiCreatorDropdownItem
        key={a.id}
        text={a.workingName ?? "No Actor"}
        icon={<ActorAvatar theme="creator-selected" actor={a} size="24" />}
        onClick={() => props.onClick(a.id)}
      />
    )),
    ...propsInTake.map((p) => (
      <PiCreatorDropdownItem
        key={p.id}
        text={p.name}
        icon={<PropIcon size={20} />}
        onClick={() => props.onClick(p.id)}
      />
    )),
  ];

  const trigger = useMemo(
    () => (
      <div
        className={
          "flex items-center w-full h-full gap-[10px] px-[4px] text-creator-text-sub text-[20px]"
        }
      >
        {selectedActor ? (
          <ActorAvatar theme="creator-selected" actor={selectedActor} size="24" />
        ) : (
          <PropIcon size={20} />
        )}
        <div className={"my-auto font-normal text-[13px] text-creator-text"}>
          {selectedActor?.workingName ?? selectedProp?.name ?? "No object"}
        </div>
      </div>
    ),
    [selectedActor, selectedProp]
  );

  return (
    <PiCreatorDropdown
      style="square"
      label={props.label}
      trigger={trigger}
      items={dropdownItems as JSX.Element[]}
    />
  );
}
